module.exports = __webpack_public_path__ + "img/默认课.9040fc51.png";